<template>
	<header class="job-listing--item-head">
		<div class="job-listing--item-head-line1">
			<div class="name">
				<a :href="editUrl">{{ jobProfile.name }}</a>
			</div>

			<a :href="editUrl" class="action orange">
				<Icon icon="settings"/>
			</a>

			<Messages
				:job-profile-list-item="jobProfileListItem"
				@close="$emit('closeMessages')"
			/>
			<Appointments
				:job-profile-list-item="jobProfileListItem"
				@closeAppointments="$emit('closeAppointments')"
			/>
			<Favorites
				:job-profile-list-item="jobProfileListItem"
				@load="$emit('loadFavorites')"
			/>
		</div>
		<ShortInfo
			:job-profile="jobProfile"
		/>
	</header>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import Messages from "@/vue/customer-area/job-profile/head/Messages";
import Appointments from "@/vue/customer-area/job-profile/head/Appointments";
import Favorites from "@/vue/customer-area/job-profile/head/Favorites";
import ShortInfo from "@/vue/customer-area/job-profile/head/ShortInfo.vue";

export default {

	components: {
		ShortInfo,
		Icon,
		Messages,
		Appointments,
		Favorites
	},

	props: {
		jobProfileListItem: {
			type: Object,
			required: true,
		},
	},

	computed: {
		jobProfile ()
		{
			return this.jobProfileListItem.jobProfile;
		},
		editUrl ()
		{
			return '/kundenbereich/jobs/' + this.jobProfile.id + '/bearbeiten';
		}
	}
}
</script>
